<template>
    <div class="body-card-border-primary container">
        <b-overlay :show="showOverlay" rounded="sm">
            
            <h2 class="pull-center">Confirmación exitosa</h2>

            <div class="row">
                <div class="col-sm-12" style="text-align: center">
                    <b-icon icon="check-circle" class="icon-size-l icon-green margin-bottom" />

                    <p>Tu cuenta se confirmó con éxito. Ya podes <strong><a href="/Login">iniciar sesión</a></strong> y configurar tu cuenta.</p>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import "@/assets/style.css"
import API_ROUTES from '@/api/routes';

export default {
    data() {
        return { 
            showOverlay: false,
        }
    },

    async created() {
        const token = new URLSearchParams(window.location.search).get('token');

        if (token !== null) {
            await this.postConfirmEmail(token);
        } else {
            //window.location.href = "/NotFound"
        }
    },

    methods: {
        async postConfirmEmail(token) {
            // console.log("Token about to send: ");
            // console.log(token);

            this.$axios.post(`${API_ROUTES.POST_USER_CONFIRM_ACCOUNT}/${token}`, token)
            .then(res => {
                // console.log(res);
                if (res.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                }
            })
            .catch(e => {
                this.showNotification("error", e);
            })
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    }
}
</script>